<template>
  <div>
    <el-button
      plain
      @click="visible = true"
    >
      <svg
        t="1764897951091"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="4806"
        width="16"
        height="16"
      >
        <path
          d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z"
          fill="#272636"
          p-id="4807"
        />
      </svg>
    </el-button>
    <el-dialog
      v-model="visible"
      :title="proxy.$t('Filter.AdvancedFilter')"
      width="950"
    >
      <div class="scrollbar">
        <el-tag
          type="primary"
          class="tag"
        >
          and
        </el-tag>
        <div class="filBox">
          <div
            v-for="(item, listIndex) in formModel"
            :key="`${item.dataIndex || 'condition'}-${listIndex}`"
          >
            <el-form
              :ref="(el) => (formRefs[listIndex] = el)"
              :model="item"
              label-width="auto"
              style="max-width: 950px"
              :rules="formRules"
            >
              <div class="flex">
                <!-- 属性 -->
                <el-form-item
                  style="width: 180px; margin-inline-end: 6px"
                  prop="dataIndex"
                >
                  <el-select
                    v-model="item.dataIndex"
                    placeholder="请选择"
                    @change="valueFn(item.dataIndex, listIndex)"
                  >
                    <el-option
                      v-for="(lba, i) in FilterData"
                      :key="i"
                      :label="lba.title"
                      :value="lba.dataIndex"
                    />
                  </el-select>
                </el-form-item>
                <!-- 属性类型 -->
                <el-form-item style="width: 120px; margin-inline-end: 6px">
                  <el-select
                    v-model="item.operator"
                    placeholder="请选择"
                    :disabled="!item.dataIndex"
                    @change="inoperatorFn(listIndex)"
                  >
                    <el-option
                      v-for="(lba, i) in item.operatorOption"
                      :key="i"
                      :label="proxy.$t(lba.label)"
                      :value="lba.value"
                    />
                  </el-select>
                </el-form-item>

                <!-- 内容  value -->

                <el-form-item
                  class="itemBox"
                  style="width: 430px; margin-inline-end: 16px"
                  prop="value"
                >
                  <!-- 选择器   单选  多选 -->
                  <el-select
                    v-if="['SELECT', 'SELECT_MULTIPLE', 'RADIO', 'CHECKBOX'].includes(item.type)"
                    v-model="item.value"
                    placeholder="请选择"
                    :multiple="item.type == 'SELECT_MULTIPLE'"
                    clearable
                    :disabled="!item.dataIndex"
                  >
                    <el-option
                      label="Zone one"
                      value="shanghai"
                    />
                  </el-select>

                  <!-- 时间选择器-->
                  <el-date-picker
                    v-else-if="['TIME_RANGE_PICKER', 'DATE_TIME'].includes(item.type) && !['DYNAMICS', 'FIXED'].includes(item.operator)"
                    v-model="item.value"
                    style="width: 100%"
                    :type="item.operator === 'BETWEEN' ? 'datetimerange' : 'datetime'"
                    clearable
                    format="YYYY-MM-DD"
                    placeholder="请选择"
                    range-separator="至"
                    start-placeholder="请选择"
                    :disabled="['EMPTY', 'NOT_EMPTY'].includes(item.operator)"
                    end-placeholder="请选择"
                    @update:value="valueChange"
                  />

                  <!-- 动态时间选择器 DYNAMICS-->
                  <TimeRangePicker
                    v-else-if="['TIME_RANGE_PICKER', 'DATE_TIME'].includes(item.type) && ['DYNAMICS', 'FIXED'].includes(item.operator)"
                    :time-range-type="item.operator"
                  />

                  <!-- 数字输入框 -->
                  <el-input-number
                    v-else-if="item.type == 'INPUT_NUMBER' || (item.type == 'INPUT_MULTIPLE' && ['COUNT_LT', 'COUNT_GT'].includes(item.operator))"
                    v-model="item.value"
                    style="width: 100%"
                    :max="999999"
                    :disabled="['EMPTY', 'NOT_EMPTY'].includes(item.operator)"
                    controls-position="right"
                    @change="handleChange"
                  >
                    <template #suffix>
                      <el-icon
                        v-if="item.value !== null && item.value !== ''"
                        class="clear-icon"
                        @click="item.value = ''"
                      >
                        <CircleClose />
                      </el-icon>
                    </template>
                  </el-input-number>
                  <!--  标签-->
                  <CrmTagInput v-else-if="['INPUT_MULTIPLE'].includes(item.type)" />

                  <!--  地址选择-->
                  <CrmCitySelect v-else-if="item.type == 'LOCATION'" />

                  <!-- 输入框 -->
                  <el-input
                    v-else
                    v-model="item.value"
                    :disabled="!item.dataIndex"
                    placeholder="请输入"
                    clearable
                  />
                </el-form-item>

                <el-form-item style="width: 40px !important">
                  <el-button
                    icon="SemiSelect"
                    circle
                    @click="delFn(listIndex)"
                  />
                </el-form-item>
              </div>
              <div
                v-if="formModel.length - 1 == listIndex"
                class="plus"
                @click="plusFn"
              >
                <el-icon class="icon">
                  <Plus />
                </el-icon>
                {{ proxy.$t('Filter.Addcondition') }}
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleReset">
            {{ proxy.$t('Shared.Reset') }}
          </el-button>
          <el-button
            type="primary"
            @click="handleFilter"
          >
            {{ proxy.$t('Shared.Filter') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { operatorOptionsMap } from './index.ts';
import TimeRangePicker from './com/TimeRangePicker.vue';
import CrmTagInput from './com/CrmTagInput.vue';
import CrmCitySelect from './com/CrmCitySelect.vue';

const { proxy } = getCurrentInstance();
const formRefs = ref([]);
const visible = ref(false);
const formModel = ref([{}]);
const isValidate = ref(false);
const emit = defineEmits(['handleFilter']);
const props = defineProps({
  filterList: {
    type: Array,
    default: () => [],
  },
});

const FilterData = ref([]);
const formRules = reactive({
  dataIndex: [{ required: true, message: '请选择筛选条件', trigger: 'blur' }],
  value: [{ required: true, message: '请输入属性值', trigger: 'blur' }],
});

onMounted(() => {
  FilterData.value = props.filterList;
});
// 筛选
const handleFilter = () => {
  emit('handleFilter');
};

// 修改属性类型
function inoperatorFn(index) {
  formModel.value[index].value = null;
}
// 属性
function valueFn(e, index) {
  FilterData.value.forEach((v) => {
    if (v.dataIndex == e) {
      formModel.value[index].value = null;
      formModel.value[index].type = v.type;
      formModel.value[index].operatorOption = operatorOptionFn(v.type, index);
      formModel.value[index].operator = getDefaultOperator(formModel.value[index].operatorOption);
    }
  });
}
//
function handleReset() {
  formModel.value = [{}];
}
// 添加筛选条件
const plusFn = async () => {
  await validateFn();
  if (isValidate.value) {
    formModel.value.push({});
  }
};
// 校验
const validateFn = async () => {
  try {
    // 遍历ref数组，逐个校验子表单
    for (let i = 0; i < formRefs.value.length; i++) {
      const formRef = formRefs.value[i];
      if (!formRef) continue;
      await formRef.validate(); // 调用el-form的校验方法
    }
    isValidate.value = true;
    // ElMessage.success('所有子表单校验通过！');
    // 后续接口提交逻辑...
  } catch {
    isValidate.value = false;
    ElMessage.error('请先完成已有的筛选！');
  }
};
// 删除筛选条件
function delFn(e) {
  formModel.value.splice(e, 1);
  formRefs.value.splice(e, 1);
}

// 选择
function operatorOptionFn(type) {
  if (!type) return;
  return operatorOptionsMap[type];
}
// 第二列默认：包含/属于/等于
function getDefaultOperator(list) {
  const data = list.map((v) => {
    return v.value;
  });
  if (data.includes('CONTAINS')) {
    return 'CONTAINS';
  }
  if (data.includes('DYNAMICS')) {
    return 'DYNAMICS';
  }
  if (data.includes('IN')) {
    return 'IN';
  }
  if (data.includes('EQUALS')) {
    return 'EQUALS';
  }
  return 'FIXED';
}
</script>
<style lang="scss" scoped>
.scrollbar {
  max-height: 60vh;
  overflow-y: auto;
  display: flex;
  align-items: center;
  padding: 15px;
  background: #eee;
  border-radius: 5px;

  .tag {
    margin-inline-end: 20px;
    cursor: pointer;
  }

  .filBox {
    flex: 1;
    border-radius: 5px;
  }

  .flex {
    display: flex;
  }

  .clear-icon {
    &:hover {
      color: var(--color-1) !important;
      cursor: pointer;
    }
  }

  .plus {
    color: var(--color-1);
    line-height: 20px;
    font-size: 16px;
    width: 160px;
    padding: 6px 0;
    position: relative;
    top: -5px;
    cursor: pointer;

    .icon {
      position: relative;
      top: 3px;
      margin-inline-end: 5px;
    }
  }
}
</style>
